import { render, staticRenderFns } from "./cmrControlPanelBottomNavButtons.vue?vue&type=template&id=523164b4"
import script from "./cmrControlPanelBottomNavButtons.vue?vue&type=script&lang=js"
export * from "./cmrControlPanelBottomNavButtons.vue?vue&type=script&lang=js"
import style0 from "./cmrControlPanelBottomNavButtons.vue?vue&type=style&index=0&id=523164b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports